import sinusoidal2D from "./Sinusoidal2D.js";
import linear2D from "./Linear2D.js";

export {sinusoidal2D, linear2D};